import { Component, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';

import { ProjectsService } from 'app/services/app/projects.service';
import { ProjectsEditorService } from '@app/services/app/projects.service';

import { ThreeDotsMenuItem } from '@core/components/helpers/navigation/three-dots-menu/three-dots-menu-item';
import * as Objects from '@core/objects';

@Component({
    selector: 'project-details-info-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class ProjectDetailsInfoHeaderComponent implements OnInit {
    public readonly ACCESS_EDIT_LABELS = "access_request_edit_labels";
    public readonly MODAL_PENDING_CHANGES = "modal_tags_pending_changes";
    public readonly MODAL_NONE = "modal_none";
    public readonly MODAL_LABELS_UPDATE_ERROR = "modal_tags_save_error";

	@Input() project: Objects.Request = null;
	@Input() title: string = '';
	public accessEditTags: boolean = false;
    public uploaded: boolean = false;
    public pendingChanges: boolean = false;

    public edit: boolean = false;
    public editorLabels: Array<Objects.Label>;
    public modalView: string = this.MODAL_NONE;
    public freezed: boolean = false;

    public menu: Array<ThreeDotsMenuItem> = [];
    protected menuTags: ThreeDotsMenuItem = {
        title: "Edit tags",
        key: "edit",
        icon: "edit-tags"
    };

    protected subs = new Subscription();
    constructor(
        private editorSrv: ProjectsEditorService,
        private projectsSrv: ProjectsService
    ){}

    ngOnInit(): void {
        this.subs.add(this.editorSrv.selectAccess(this.ACCESS_EDIT_LABELS)
            .subscribe((access: boolean) => {
                this.accessEditTags = access;
                this.updateMenu(this.menuTags,this.accessEditTags);
            }));
        this.subs.add(this.projectsSrv.selectUploadedVersions().subscribe((versions: Array<Objects.Version>) => this.uploaded = (versions!= null && versions.length > 0)   ));        
        
        this.subs.add(this.projectsSrv.selectLabelsUpdateStatus().subscribe((status: number) => {
            switch (status) {
                case 2: // Done
                    this.freezed = false;
                    break;
                case 3: // Error
                    this.pendingChanges = true;
                    this.modalView = this.MODAL_LABELS_UPDATE_ERROR;
                    break;
            }
        }));
        this.editorLabels = this.project.labels;
    }
    ngOnDestroy() {
        this.subs.unsubscribe();
    }

    onMenuSelect(key: string) {
        switch(key) {
            case "edit":
                this.toggleEdit();
        }
    }

    onModalExitEdition(){
        this.edit = false;
        this.modalView = this.MODAL_NONE; 
        this.resetEditorLabels()
    }

    onModalCancel(){
        this.modalView = this.MODAL_NONE;
    }

    onModalErrorDismiss(){
        this.modalView = this.MODAL_NONE;
        if(this.freezed){
            this.freezed = false;
            this.resetEditorLabels();
        }
    }

    toggleEdit(){
        // when toggle edit, if we have pending changes, we show the modal
        if (this.edit && this.pendingChanges){
            this.modalView = this.MODAL_PENDING_CHANGES;
            return;
        }
        // if no changes pending, we just toggle edit mode
        this.edit = !this.edit;
        
    }

    setLabels(labels: Array<Objects.Label>) {
        this.editorLabels = labels;
        this.pendingChanges = true;
    }

    onTagsConfirm() {
        this.freezed = true;
        this.projectsSrv.setLabels(this.editorLabels);
        this.pendingChanges = false;
    }

    protected updateMenu(item: ThreeDotsMenuItem, addItem:boolean = true) {
        this.menu = this.menu.filter((i: ThreeDotsMenuItem) => item.key != i.key);
        if(addItem){
            this.menu.push(item);
        }
    }

    protected resetEditorLabels(){
        // reset labels if we are exiting edit mode to be all again when back
        if (!this.edit) {
            this.editorLabels = this.project.labels;
            this.pendingChanges = false;
        }
    }

}
